import { styled } from '@mui/material';
import { FormControlLabel } from '@mui/material';

export const CheckboxLabel = styled(FormControlLabel)<{ active?: boolean }>(
  ({ theme, active }) => ({
    margin: 0,
    color: active ? theme.palette.primary.main : theme.palette.text.secondary,
    '&:hover': {
      color: active ? theme.palette.common.main2 : theme.palette.primary.main,
      '& :not(.Mui-checked) .svg-icon circle': {
        stroke: theme.palette.primary.main,
      },
      '& .Mui-checked .svg-icon circle': {
        fill: theme.palette.common.main2,
      },
    },
    '& .MuiCheckbox-root': {
      padding: 0,
      marginRight: theme.spacing(1),
    },
  }),
);
